import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-add-animal-deworming',
  templateUrl: './add-animal-deworming.component.html',
  styleUrls: ['./add-animal-deworming.component.css']
})
export class AddAnimalDewormingComponent implements OnInit {

  deworming_detail: FormGroup;

  returnUrl = "/dashboard/RottweilerDogsAnimalmanagement";
  addDiseaseFormValue: any;
  addUrl: any;
  route: any;
  getlistApi: any;
  getDewormingListData: any
  fragment: any;
  loginresponse: any;
  cby_mby: any;
  addDewormingFormValue: any;

  deworming_name: any;
  deworming_date: any;
  batch_number: any;
  expiry_date: any;

  error_flag: boolean = false;

  constructor(private router: Router, private commonService: CommonService, private formbulder: FormBuilder) {

    this.deworming_detail = this.formbulder.group({

      deworming_name: ['', Validators.required],
      deworming_date: ['', Validators.required],
      batch_number: ['', Validators.required],
      expiry_date: ['', Validators.required]

    })

  }

  async ngOnInit() {
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby = this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh');
    this.getlistApi = "/parasite";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {
        this.getDewormingListData = res.data;
      })
      console.log('parasite',this.getDewormingListData)
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
    }, 1000);
    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });
  }
  async AnimalDeworming() {

    if (!this.deworming_name || !this.deworming_date || !this.batch_number || !this.expiry_date) {

      if (!this.deworming_name) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.deworming_date) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.batch_number) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }
      if (!this.expiry_date) {
        this.error_flag = true;
      } else {
        this.error_flag = false;
      }

      return;
      
    }

    var farmid = sessionStorage.getItem('farmid');
    var Animalid = sessionStorage.getItem('animalid');
    var speciesid = sessionStorage.getItem('speciesid');
    var breedid = sessionStorage.getItem('breedid');
    var ageid = sessionStorage.getItem('ageid');
    this.addDewormingFormValue = {
      "species_id": speciesid,
      "breed_id": breedid,
      "farm_id": farmid,
      "animal_code": Animalid,
      "age_group": ageid,
      "deworming_name": $("#dewormingname").val(),
      "expiry_date": $("#ExpiryDate").val(),
      "batch_number": $("#batchNumber").val(),
      "deworming_date": $("#DewormingDate").val(),
      "deworming_description": $("#Description").val(),
      "cby": this.cby_mby,
      "status": 1,
      "is_active": 1
    };
    console.log('Details', this.addDewormingFormValue)
    this.addUrl = "/animal_management/deworming";
    (await this.commonService.postApi(this.addUrl, this.addDewormingFormValue)).subscribe(
      data => {
        alert("Data added successfully");
      });
    setTimeout(
      (): void => {

        this.router.navigate([this.returnUrl, { fragment: 'Deworming' }]);

      },
      500
    );
    //}
  }

  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
